import React from 'react';
import { NOT_FOUND } from '../../utils/constants';
import { getText } from '../../utils/functions';

function NotFound({
	translate,
	colors,

	/* OPTIONAL PROPS */
	classNameDIV = 'w-full px-8 md:px-30 lg:px-52 flex flex-col h-full space-y-12 items-center content-center justify-center',
	styleDIV,
	classNameIMG = 'max-h-52 md:max-h-80 mb-7',
	styleIMG,
	classNameTEXT = 'md:text-xl',
	styleTEXT,
}) {
	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: colors?.background,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleIMG = {
	};
	const defaultStyleTEXT = {
		color: colors?.primary,
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleIMG = { ...defaultStyleIMG, ...styleIMG };
	const overrideStyleTEXT = { ...defaultStyleTEXT, ...styleTEXT };

	return <div
		id='NOT_FOUND'
		className={classNameDIV}
		style = {overrideStyleDIV}
	>
		<img
			src={NOT_FOUND.img}
			className={classNameIMG}
			style={overrideStyleIMG}
		/>
		<div
			className={classNameTEXT}
			style= {overrideStyleTEXT}
			dangerouslySetInnerHTML={{ __html: getText(NOT_FOUND.information, translate) }}
		/>
	</div>;
}

export default NotFound;
